import { FaLaptopCode, FaCodeBranch, FaMobileAlt, FaPen, FaBullhorn, FaBlogger, FaGlobe } from "react-icons/fa";

export const SERVICES = [
  {
    title: "Web Developer",
    description: "As a Fullstack Web Developer, I build responsive, scalable web applications using modern frameworks and technologies like React, Node.js, and MongoDB.",
    icon: <FaLaptopCode />,
  },
  {
    title: "Software Engineer",
    description: "With expertise in algorithms, system design, and efficient problem-solving, I create robust software solutions tailored to business needs and technical requirements.",
    icon: <FaCodeBranch />,
  },
  {
    title: "Game Developer",
    description: "I specialize in game development, creating immersive experiences for PC and mobile platforms using game engines like Unity and Unreal Engine, along with creative design.",
    icon: <FaMobileAlt />,
  },
  {
    title: "Content Creator",
    description: "As a Content Creator, I engage with audiences by producing insightful and engaging content on platforms like YouTube, Medium, and personal blogs, sharing knowledge on software engineering, web development, and more.",
    icon: <FaPen />,
  },
  {
    title: "Public Speaker",
    description: "I speak at conferences and workshops, sharing my expertise in software engineering, development practices, and technology trends. I aim to inspire and educate future professionals in the field.",
    icon: <FaBullhorn />,
  },
  {
    title: "Blogger",
    description: "I share my experiences and knowledge through blogs, offering in-depth insights on programming, software engineering best practices, and emerging technologies, helping others grow in the tech community.",
    icon: <FaBlogger />,
  },
  {
    title: "Traveller",
    description: "I enjoy exploring new cultures and technologies around the world, drawing inspiration from my travels to bring fresh perspectives into my professional work, especially in creative and game development.",
    icon: <FaGlobe />,
  },
];